/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { type FunctionComponent } from 'react'

import { EuiEmptyPrompt, EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import type { BudgetConfigurationValues } from '../../../types'

const messages = {
  'no-scope-selected': {
    id: 'billing.notifications.budgets.budget-settings.cost-trends.pending-scope-selection',
    defaultMessage: 'Select scope to visualize trend',
  },
  'no-instance-selected': {
    id: 'billing.notifications.budgets.budget-settings.cost-trends.pending-instance-selection',
    defaultMessage: 'Select an instance to visualize trend',
  },
}

type Props = {
  scopeType: BudgetConfigurationValues['scopeType']
  scopeValues: BudgetConfigurationValues['scopeValues']
}

const NoScopeSelectedFallback: FunctionComponent<Props> = ({ scopeType, scopeValues }) => {
  const fallbackMessage =
    scopeType === 'cloud_resource' && !scopeValues?.length
      ? messages['no-instance-selected']
      : messages['no-scope-selected']

  return (
    <EuiEmptyPrompt
      iconType='chartBarVertical'
      body={
        <EuiText size='s'>
          <FormattedMessage {...fallbackMessage} />
        </EuiText>
      }
    />
  )
}

export default NoScopeSelectedFallback
